var path = '/home/travis/build/orizens/echoes/src/components/feed-filter/feed-filter.tpl.html';
var html = "<ul id=feed-filter class=\"nav navbar-nav feed-filter nicer-ux\"><li class=feed-item ng-repeat=\"feed in vm.data.items\" ng-class=\"{'active': feed === vm.active}\" ng-click=vm.setFeed(feed)><a title=\"Explore {{:: feed.label}}\" href=#explore><i class=\"fa fa-{{:: feed.icon}}\"></i> {{:: feed.label}}</a></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/feed-filter/feed-filter.tpl.html
 ** module id = 122
 ** module chunks = 1
 **/